import { useTheme } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useSearchParams } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Filter } from "../../../../types/filter";
import { DaylightDateFormat } from "../../../../constants/DaylightDateFormat";

type ETAFilterProps = { filter: Filter; timeZone?: string };

export const ETAFilter = ({ filter, timeZone }: ETAFilterProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const theme = useTheme();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        timezone={timeZone}
        sx={{
          backgroundColor: theme.palette.background.paper,
          "& .MuiInputBase-input": {
            minWidth: "180px",
          },
        }}
        label="LH ETA"
        format={DaylightDateFormat.DATE_WITH_SHORT_DAY_OF_WEEK_AND_TIME}
        defaultValue={
          searchParams.get(filter.queryParam)
            ? searchParams.get(filter.queryParam) !== "All"
              ? dayjs(searchParams.get(filter.queryParam)).tz(timeZone)
              : null
            : null
        }
        onChange={(eta) => {
          setSearchParams((prev) => {
            const queryParam = filter.queryParam;
            const newParams = new URLSearchParams(prev);
            newParams.set(
              queryParam,
              eta
                ? eta
                    .tz(timeZone)
                    .format(DaylightDateFormat.ISO_DATE_TIME_WITH_TIMEZONE)
                : "All"
            );
            return newParams;
          });
        }}
        slotProps={{
          actionBar: {
            actions: ["clear", "accept"],
          },
          field: {
            readOnly: true,
          },
        }}
      />
    </LocalizationProvider>
  );
};
